import { Deserializable } from '../deserializable';
import { ArtefactDetailsDto } from '../dto/case-overview/artefact-details-dto.model';

export class CaseActivityDetails implements Deserializable {
  public ApplicationCaseActivities: Array<ArtefactDetailsDto>;
  public ApplicationCaseAdvisedActivities: Array<ArtefactDetailsDto>;

  deserialize(input: any): this {
    Object.assign(this, input);
    this.ApplicationCaseActivities = input.ApplicationCaseActivities.map((artefactDetailsDto: ArtefactDetailsDto) =>
      new ArtefactDetailsDto().deserialize(artefactDetailsDto)
    );
    this.ApplicationCaseAdvisedActivities = input.ApplicationCaseAdvisedActivities.map(
      (artefactDetailsDto: ArtefactDetailsDto) => new ArtefactDetailsDto().deserialize(artefactDetailsDto)
    );

    return this;
  }
}
